export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./btn-green.vue?vue&type=template&id=15f481dc&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/btn-green/btn-green.vue?vue&type=template&id=15f481dc&
// module id = 1066
// module chunks = 0